import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { fmtEUR, fmtDate } from "../lib/format";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Progress } from "../components/ui/progress";
import { HardHat } from "lucide-react";

export default function Cantieri() {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/cantieri").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="text-muted-foreground">Caricamento...</div>;
  return (
    <div className="space-y-5" data-testid="page-cantieri">
      <div><h1 className="text-3xl font-display font-bold text-primary flex items-center gap-2"><HardHat className="w-7 h-7" /> Cantieri</h1><p className="text-sm text-muted-foreground">Avanzamento lavori, SAL e diario per ogni operazione in cantiere</p></div>
      {rows.length === 0 && <Card className="p-8 text-center text-muted-foreground">Nessun cantiere attivo. Porta un'operazione in stato "cantiere attivo" o registra un SAL dal dettaglio operazione.</Card>}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {rows.map((c) => (
          <Card key={c.id} className="p-4 cursor-pointer hover:shadow-md transition-shadow" onClick={() => nav(`/operazioni/${c.id}`)} data-testid="cantiere-card">
            <div className="flex items-start justify-between"><div className="font-semibold">{c.nome_operazione}</div><Badge variant="outline" className="capitalize">{c.stato}</Badge></div>
            <div className="text-xs text-muted-foreground">{c.comune} · {c.n_sal} SAL · ultimo diario {c.ultimo_diario ? fmtDate(c.ultimo_diario) : "—"}</div>
            <div className="mt-3 flex items-center gap-2"><Progress value={c.avanzamento} className="h-2" /><span className="text-sm font-semibold kpi-num">{c.avanzamento.toLocaleString("it-IT")} %</span></div>
            <div className="grid grid-cols-3 gap-2 mt-3 text-xs"><div><div className="text-muted-foreground">Budget</div><div className="font-medium">{fmtEUR(c.budget_lavori)}</div></div><div><div className="text-muted-foreground">SAL</div><div className="font-medium">{fmtEUR(c.sal_totale)}</div></div><div><div className="text-muted-foreground">Pagati</div><div className="font-medium text-emerald-600">{fmtEUR(c.sal_pagati)}</div></div></div>
          </Card>))}
      </div>
    </div>
  );
}
